import { createReducer } from '../../utils';
import types from './types';

// TODO Make token null initially
export const initialState = {
    token: ''
};

const ACTION_HANDLERS = {
    [types.SET_USER_TOKEN]: (state, action) => ({
        ...state,
        token: action.payload
    })
};

export default createReducer(ACTION_HANDLERS, initialState);
